import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-enlarge-get-dashboard-widget',
  templateUrl: './enlarge-get-dashboard-widget.component.html',
  styleUrls: ['./enlarge-get-dashboard-widget.component.scss']
})
export class EnlargeGetDashboardWidgetComponent implements OnInit {

  chartTitle :string;
  showingChartId: string;
  passedDataSource : any;
  constructor(
    public dialogRef: MatDialogRef<EnlargeGetDashboardWidgetComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, ) { }

  ngOnInit() {
    this.showingChartId = this.data.chartId;
    this.chartTitle = this.data.chartTitle;
    this.passedDataSource = this.data.dataSource;   
  }

  onNoClick(){
    this.dialogRef.close();
  }

}
